function Loader() {
  return <div className="loader">Загрузка...</div>;
}

export default Loader;
